const products = [
  {
    id: 1,
    title: "Babybear Bag 🐻",
    handle: "babybear-bag",
    defaultVariantId: "50216387019033",
    variants: [
      { name: "Red", id: "50216386953497", price: 49.95, comparePrice: 79.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-1.jpg?v=1777061004" },
      { name: "Black", id: "50216387051801", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Black8.jpg?v=1777061004" },
      { name: "Blue", id: "50216387019033", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-3.jpg?v=1777061004" },
      { name: "Grey", id: "50216386986265", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-2.jpg?v=1777061004" }
    ]
  },
  {
    id: 2,
    title: "CozyCub Baby Sleeping Bag 🧸",
    handle: "cozycub-baby-sleeping-bag",
    variants: [
      { name: "Pink 0-3 Month", id: "47437268680985", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" },
      { name: "Pink 3-6 Month", id: "50190157676825", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" },
      { name: "Pink 6-9 Month", id: "50190157709593", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" },
      { name: "Blue 0-3 Month", id: "47437268648217", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" },
      { name: "Blue 3-6 Month", id: "50190157742361", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" },
      { name: "Blue 6-9 Month", id: "50190157775129", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" },
      { name: "White 0-3 Month", id: "47437268058393", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" },
      { name: "White 3-6 Month", id: "50190157807897", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" },
      { name: "White 6-9 Month", id: "50190157840665", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" }
    ]
  },
  {
    id: 3,
    title: "Carrybear Bag 🐼",
    handle: "carrybear-bag",
    defaultVariantId: "45336597004569",
    variants: [
      { name: "White", id: "49507609739545", price: 199.95, comparePrice: 249.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20240816_202224-removebg-preview.png?v=1744515289" },
      { name: "Pink", id: "45336597004569", price: 199.95, comparePrice: 249.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/0H3A0011-2.jpg?v=1777062659" },
      { name: "Blue", id: "45336586584345", price: 199.95, comparePrice: 249.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20230714-WA0003_1.jpg?v=1744515289" }
    ]
  },
  {
    id: 4,
    title: "Butterfly Comfort Nursing Pillow 🦋",
    handle: "butterfly-comfort-nursing-pillow",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20231016-WA0087.jpg?v=1697475434",
    variants: [
      { name: "Pink", id: "50216413757721", price: 34.95, comparePrice: 49.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/51gqicJn-0L.-AC_SL1500.jpg?v=1722639414" },
      { name: "Grey", id: "50216413790489", price: 34.95, comparePrice: 49.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_6f0a4b72-93f1-447a-9f4d-378f80bc4fa4.png?v=1712627607" }
    ]
  },
  {
    id: 5,
    title: "Pandallow 🤍",
    handle: "pandallow",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1.jpg?v=1735742378",
    variants: [
      { name: "ZigZag", id: "50165296365849", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0046.jpg?v=1777063574" },
      { name: "Blue ZigZag", id: "52012817023257", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_959b261f-1b60-41b6-8e30-ce8f6008ca5a.png?v=1777063964" },
      { name: "Night Sky", id: "50165296398617", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0047.jpg?v=1777063594" },
      { name: "Pink Stars", id: "50165296431385", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0048.jpg?v=1777063614" },
      { name: "Grey Stars", id: "50165296464153", price: 14.97, comparePrice: 29.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0049.jpg?v=1777063632" },
      { name: "White Stars", id: "50165296496921", price: 14.97, comparePrice: 29.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0051.jpg?v=1777063691" },
      { name: "Crown", id: "50165296529689", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0050.jpg?v=1777063667" }
    ]
  },
  {
    id: 6,
    title: "Cuddle Pouch Hoodie 💕",
    handle: "cuddle-pouch-hoodie",
    defaultVariantId: "47999663505689",
    variants: [
      { name: "Red-M", id: "47978792288537", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9406e812-e15e-49b1-86af-214c028fd927.png?v=1708434223" },
      { name: "Red-L", id: "47999655805209", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9406e812-e15e-49b1-86af-214c028fd927.png?v=1708434223" },
      { name: "Red-XL", id: "47999655837977", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9406e812-e15e-49b1-86af-214c028fd927.png?v=1708434223" },
      { name: "Red-2XL", id: "47999663505689", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9406e812-e15e-49b1-86af-214c028fd927.png?v=1708434223" },
      { name: "Light Purple-M", id: "47978792419609", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightpurple.png?v=1708110990" },
      { name: "Light Purple-L", id: "47999655870745", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightpurple.png?v=1708110990" },
      { name: "Light Purple-XL", id: "47999655903513", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightpurple.png?v=1708110990" },
      { name: "Light Purple-2XL", id: "47999663538457", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightpurple.png?v=1708110990" },
      { name: "Purple-M", id: "47978792550681", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/purple.png?v=1708434223" },
      { name: "Purple-L", id: "47999655936281", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/purple.png?v=1708434223" },
      { name: "Purple-XL", id: "47999655969049", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/purple.png?v=1708434223" },
      { name: "Purple-2XL", id: "47999663571225", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/purple.png?v=1708434223" },
      { name: "Light Grey-M", id: "47978792681753", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightgrey.png?v=1708434223" },
      { name: "Light Grey-L", id: "47999656001817", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightgrey.png?v=1708434223" },
      { name: "Light Grey-XL", id: "47999656034585", price: 19.95, comparePrice: 44.98, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightgrey.png?v=1708434223" },
      { name: "Light Grey-2XL", id: "47999663603993", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightgrey.png?v=1708434223" }
    ]
  }
];

let stockSynced = false;

async function syncShopifyStock() {
  for (const product of products) {
    try {
      const res = await fetch(`/products/${product.handle}.js`);
      if (!res.ok) continue;

      const data = await res.json();

      product.variants.forEach(variant => {
        const liveVariant = data.variants.find(v => String(v.id) === String(variant.id));
        if (liveVariant) {
          variant.inStock = liveVariant.available;
          variant.price = liveVariant.price / 100;
          variant.comparePrice = liveVariant.compare_at_price ? liveVariant.compare_at_price / 100 : null;
        }
      });
    } catch (error) {
      console.warn("Stock/price sync failed:", product.title);
    }
  }

  stockSynced = true;
}

function getSavePercentage(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return null;
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

function getDefaultVariant(product) {
  if (product.defaultVariantId) {
    const chosen = product.variants.find(v => String(v.id) === String(product.defaultVariantId));
    if (chosen && chosen.inStock) return chosen;
  }

  return product.variants.find(v => v.inStock) || product.variants[0];
}

function renderProducts() {
  const grid = document.getElementById("productsGrid");
  if (!grid) return;

  grid.innerHTML = "";

  products.forEach(product => {
    const firstVariant = getDefaultVariant(product);
    const displayImage = product.defaultImage || firstVariant.image;
    const savePercent = getSavePercentage(firstVariant.price, firstVariant.comparePrice);

    const card = document.createElement("article");
    card.className = "product-card";
    card.setAttribute("data-product-handle", product.handle);

    let dropdownOptions = "";

    product.variants.forEach(variant => {
      const selected = String(variant.id) === String(firstVariant.id) ? "selected" : "";
      const soldOutClass = !variant.inStock ? "sold-out-option" : "";

      dropdownOptions += `
        <option
          value="${variant.id}"
          data-price="${variant.price}"
          data-compare="${variant.comparePrice || ""}"
          data-image="${variant.image}"
          data-title="${product.title}"
          data-instock="${variant.inStock}"
          class="${soldOutClass}"
          ${selected}>
          ${variant.name}
        </option>
      `;
    });

    card.innerHTML = `
      <div class="product-image-container">
        ${savePercent ? `<span class="sale-badge">SAVE ${savePercent}%</span>` : ""}

        <img src="${displayImage}" alt="${product.title}" class="product-image" loading="lazy">

        <div class="image-overlay">
          <a href="/products/${product.handle}" class="view-details-btn">
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/>
            </svg>
            <span>View Details</span>
          </a>
        </div>

        <button class="image-cart-btn add-to-cart-mobile ${!firstVariant.inStock ? "sold-out-mobile" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </button>

        ${!firstVariant.inStock ? `<div class="mobile-sold-out">Sold Out</div>` : ""}
      </div>

      <div class="product-info">
        <h3 class="product-title" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${product.title}</h3>

        <div class="variant-selector">
          <select class="variant-dropdown ${!firstVariant.inStock ? "selected-sold-out" : ""}">
            ${dropdownOptions}
          </select>
        </div>

        <div class="product-price">
          <span class="current-price">$${firstVariant.price.toFixed(2)}</span>
          ${firstVariant.comparePrice ? `<span class="compare-price">$${firstVariant.comparePrice.toFixed(2)}</span>` : ""}
        </div>

        <button class="add-to-cart-btn add-to-cart-desktop ${!firstVariant.inStock ? "sold-out" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          <span>${firstVariant.inStock ? "Add to Cart" : "Sold Out"}</span>
        </button>
      </div>
    `;

    grid.appendChild(card);
  });

  attachEventListeners();
}

function attachEventListeners() {
  // Card click redirection - redirects to product page when clicking anywhere on the card
  document.querySelectorAll(".product-card").forEach(card => {
    card.addEventListener("click", function(e) {
      // Don't redirect if clicking on dropdown, add to cart button, or mobile cart button
      if (
        e.target.tagName === "SELECT" ||
        e.target.tagName === "BUTTON" ||
        e.target.closest(".variant-dropdown") ||
        e.target.closest(".add-to-cart-desktop") ||
        e.target.closest(".add-to-cart-mobile") ||
        e.target.closest(".image-cart-btn") ||
        e.target.closest(".view-details-btn")
      ) {
        return;
      }
      
      const productHandle = this.dataset.productHandle;
      if (productHandle) {
        window.location.href = `/products/${productHandle}`;
      }
    });
  });

  // Variant dropdown change handler
  document.querySelectorAll(".variant-dropdown").forEach(dropdown => {
    dropdown.addEventListener("change", function (e) {
      e.stopPropagation();
      const card = this.closest(".product-card");
      const option = this.options[this.selectedIndex];

      const variantId = option.value;
      const price = parseFloat(option.dataset.price);
      const compare = option.dataset.compare ? parseFloat(option.dataset.compare) : null;
      const image = option.dataset.image;
      const productTitle = option.dataset.title;
      const inStock = option.dataset.instock === "true";

      const imageEl = card.querySelector(".product-image");
      const priceEl = card.querySelector(".current-price");
      const compareEl = card.querySelector(".compare-price");
      const desktopBtn = card.querySelector(".add-to-cart-desktop");
      const mobileBtn = card.querySelector(".add-to-cart-mobile");
      const imageContainer = card.querySelector(".product-image-container");

      if (imageEl) imageEl.src = image;
      if (priceEl) priceEl.textContent = `$${price.toFixed(2)}`;

      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = `$${compare.toFixed(2)}`;
          compareEl.style.display = "inline";
        } else {
          compareEl.style.display = "none";
        }
      }

      if (desktopBtn) {
        desktopBtn.dataset.variantId = variantId;
        desktopBtn.dataset.price = price;
      }
      if (mobileBtn) {
        mobileBtn.dataset.variantId = variantId;
        mobileBtn.dataset.price = price;
      }

      const existingBadge = card.querySelector(".mobile-sold-out");

      if (inStock) {
        this.classList.remove("selected-sold-out");

        if (desktopBtn) {
          desktopBtn.disabled = false;
          desktopBtn.classList.remove("sold-out");
          const span = desktopBtn.querySelector("span");
          if (span) span.textContent = "Add to Cart";
        }

        if (mobileBtn) {
          mobileBtn.disabled = false;
          mobileBtn.classList.remove("sold-out-mobile");
        }

        if (existingBadge) existingBadge.remove();
      } else {
        this.classList.add("selected-sold-out");

        if (desktopBtn) {
          desktopBtn.disabled = true;
          desktopBtn.classList.add("sold-out");
          const span = desktopBtn.querySelector("span");
          if (span) span.textContent = "Sold Out";
        }

        if (mobileBtn) {
          mobileBtn.disabled = true;
          mobileBtn.classList.add("sold-out-mobile");
        }

        if (!existingBadge && imageContainer) {
          const badge = document.createElement("div");
          badge.className = "mobile-sold-out";
          badge.textContent = "Sold Out";
          imageContainer.appendChild(badge);
        }
      }
    });
  });

  // Desktop add to cart button
  document.querySelectorAll(".add-to-cart-desktop").forEach(button => {
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });

  // Mobile add to cart button
  document.querySelectorAll(".add-to-cart-mobile").forEach(button => {
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  renderProducts();

  syncShopifyStock().then(function () {
    renderProducts();
  });
});